import { FunctionFactory } from 'survey-core';
import { Gender } from "./gender";
import { Physiology } from './physiology';
import { getGenderKey } from '../features/utils';
import { loc } from '../i18n/survey';

enum AreaBody {
  Belly = 'Belly',
  LoveHandles = 'Love Handles',
  Chest = 'Chest',
  LowerBack = 'Lower Back',
  Legs = 'Legs',
  Arms = 'Arms',
  Hips = 'Hips',
  Equally = 'Equally',
}

const areaBodyQuestion = {
  name: 'areaBody',
  title: loc('quiz.areaBody.title'),
  description: loc('quiz.areaBody.description'),
  descriptionLocation: 'underTitle',
  choices: [
    {
      value: AreaBody.Belly,
      text: loc('quiz.areaBody.choices.belly'),
    },
    {
      value: AreaBody.LoveHandles,
      text: loc('quiz.areaBody.choices.loveHandles'),
    },
    {
      value: AreaBody.Chest,
      text: loc('quiz.areaBody.choices.chest'),
    },
    {
      value: AreaBody.LowerBack,
      text: loc('quiz.areaBody.choices.lowerBack'),
    },
    {
      value: AreaBody.Legs,
      text: loc('quiz.areaBody.choices.legs'),
    },
    {
      value: AreaBody.Arms,
      text: loc('quiz.areaBody.choices.arms'),
    },
    {
      value: AreaBody.Hips,
      text: loc('quiz.areaBody.choices.hips'),
    },
    {
      value: AreaBody.Equally,
      text: loc('quiz.areaBody.choices.equally'),
    },
  ],
  isRequired: true,
  type: 'checkbox',
  maxSelectedChoices: 3,
};

const areaBodyGenderExpression = {
  name: 'areaBodyGenderText',
  expression: 'renderAreaBodyGenderText({gender}, {physiology})',
};

function renderAreaBodyGenderText(params: any[]): string {
  if (params === undefined || params === null) return '';

  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male:
      return `man`;
    case Gender.Female:
      return `woman`;
  }
}

FunctionFactory.Instance.register('renderAreaBodyGenderText', renderAreaBodyGenderText);

export { AreaBody, areaBodyQuestion, areaBodyGenderExpression };
